<template>
  <section
    :class="['common-btn-wrapper', hasTips ? 'hasTips' : '', type, fissionGame]"
  >
    <button
      :class="['common-btn', animation ? 'breathing-btn' : '', fissionGame]"
      @click="click"
    >
      <p class="flex-center">{{ btnText }}</p>
      <popover-tip
        :text="tipsText"
        :class="['tips', type]"
        v-if="hasTips"
        :registerAwardsType="registerAwardsType"
        :registerAwardsNum="registerAwardsNum"
        :couponType="couponType"
        :btnType="btnType"
        :shareDesc="shareDesc"
      />
    </button>
  </section>
</template>
<script>
  import { mapState } from 'vuex'
  import PopoverTip from '../PopoverTip'

  export default {
    name: 'common-btn',
    components: {
      PopoverTip,
    },
    props: {
      // 按钮文案
      btnText: {
        type: String,
        default: '',
      },
      // 按钮“呼吸”动画
      animation: {
        type: Boolean,
        default: true,
      },
      type: {
        type: String,
        default: 'page', // page: 页面, popup: 弹框
      },
      // 是否有按钮tips提示
      hasTips: {
        type: Boolean,
        default: true,
      },
      // tips提示文案
      tipsText: {
        type: String,
        default: '',
      },
      // tips提示left位置
      tipsLeft: {
        type: String,
        default: '50%',
      },
      registerAwardsType: {
        type: String,
        default: '',
      },
      registerAwardsNum: {
        type: [String, Number],
        default: '',
      },
      couponType: {
        type: [Number, String],
        default: '',
      },
      btnType: {
        type: String,
        default: '',
      },
      shareDesc: {
        type: String,
        default: '',
      },
    },
    computed: {
      ...mapState(['fissionGame']),
    },
    methods: {
      click() {
        this.$emit('click')
      },
    },
  }
</script>
<style lang="scss" scoped>
  .common-btn-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    &.hasTips {
      height: 220px;
      &.page {
        height: 260px;
      }
      &.popup {
        height: 152px;
      }
    }
    .common-btn {
      width: 780px;
      height: 176px;
      font-family: 'MiSans', 'Noto Sans';
      font-weight: 900;
      color: #ddd;
      margin: 20px auto;
      position: relative;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      padding-bottom: 2%;
      box-sizing: border-box;
      & > p {
        height: 100%;
        font-size: 60px;
        line-height: 100%;
      }
      &.mobile-legends {
        background-image: url('~@/assets/images/activities/fission/mobile-legends/button-bg.png');
        & > p {
          // background: linear-gradient(180deg, #ffffff 17.99%, #bcbcbc 74.82%);
          // background-clip: text;
          // -webkit-background-clip: text;
          // -webkit-text-fill-color: transparent;
          // filter: drop-shadow(0px 0px 13px rgba(27, 13, 116, 0.64));
          text-shadow: 0px 0px 13px rgba(27, 13, 116, 0.64);
        }
      }
      &.pubgm {
        background-image: url('~@/assets/images/activities/fission/pubgm/button-bg.png');
        & > p {
          text-shadow: 0px 0px 13px rgba(27, 13, 116, 0.64);
        }
      }
      &.genshin {
        width: 781px;
        height: 192px;
        background-image: url('~@/assets/images/activities/fission/genshin/button-bg.png');
        & > p {
          // background: linear-gradient(180deg, #ffffff 17.99%, #f1efd8 74.82%);
          // background-clip: text;
          // -webkit-background-clip: text;
          // -webkit-text-fill-color: transparent;
          // filter: drop-shadow(0px 5px 14px rgba(165, 99, 38, 0.64));
          color: #fff;
          text-shadow: 0px 5px 14px rgba(165, 99, 38, 0.64);
        }
      }
      .tips {
        padding: 15px 35px 17px 30px;
        position: absolute;
        left: 50%;
        bottom: -55%;
        z-index: 9;
        transform: translateX(-50%);
        width: 100%;
        &.popup {
          bottom: -90%;
        }
      }
    }
    &.registerBtn .common-btn .tips {
      width: 96%; // 气泡框宽度比注册按钮略窄
    }
    &.page {
      .common-btn > p {
        font-size: 90px;
      }
    }
  }
  .gt-layout.login-btn-wrapper.popup-card {
    .common-btn-wrapper {
      .common-btn {
        margin: 10px auto;
      }
    }
  }
  // 分享者弹窗登录按钮
  .login-btn-wrapper.popup-card {
    .common-btn-wrapper .common-btn {
      background-position: center;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      width: 550px;
      &.pubgm {
        height: 114px;
        background-image: url('~@/assets/images/activities/fission/pubgm/popup-btn-owner.png');
      }
      &.mobile-legends {
        height: 118px;
        background-image: url('~@/assets/images/activities/fission/mobile-legends/popup-btn-owner.png');
      }
      &.genshin {
        height: 118px;
        background-image: url('~@/assets/images/activities/fission/genshin/popup-btn-owner.png');
      }
    }
  }
  // 助力者弹窗
  .isGuest {
    // 登录按钮
    .login-btn-wrapper.popup-card {
      .common-btn-wrapper .common-btn {
        width: 600px;
        height: 100px;
        background-image: url('~@/assets/images/activities/fission/mobile-legends/popup-btn-guest.png');
        font-size: 48px;
        margin: 10px auto;
        &.pubgm {
          background-image: url('~@/assets/images/activities/fission/pubgm/popup-btn-guest.png');
        }
        &.genshin {
          background-image: url('~@/assets/images/activities/fission/genshin/popup-btn-guest-login.png');
        }
      }
    }
    // 注册按钮，调起登录面板
    .registerBtn {
      .common-btn {
        width: 100%;
        height: 108px;
        margin-top: 31px;
        background-position: center;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        &.mobile-legends {
          height: 118px;
          background-image: url('~@/assets/images/activities/fission/mobile-legends/popup-btn-guest.png');
        }
        &.pubgm {
          height: 114px;
          background-image: url('~@/assets/images/activities/fission/pubgm/popup-btn-guest.png');
        }
        &.genshin {
          height: 114px;
          background-image: url('~@/assets/images/activities/fission/genshin/popup-btn-guest.png');
        }
      }
    }
  }
</style>
